import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/devices/add')({
  beforeLoad: () => {
    throw redirect({ to: '/devices' })
  },
})
